import { render, staticRenderFns } from "./drink_water.vue?vue&type=template&id=0d000c30&scoped=true&"
import script from "./drink_water.vue?vue&type=script&lang=js&"
export * from "./drink_water.vue?vue&type=script&lang=js&"
import style0 from "./drink_water.vue?vue&type=style&index=0&id=0d000c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d000c30",
  null
  
)

export default component.exports